import { Topic } from '@/app/api';
import Link from 'next/link';
import { useMemo } from 'react';
import { Trans } from 'react-i18next';

type TopicLinkProps = {
  topic: Topic;
};

export const TopicLink = ({ topic }: TopicLinkProps) => {
  const slug = topic?.slug;

  const topicLink = useMemo(() => {
    const baseUrl = process.env.NEXT_PUBLIC_REDIRECT_URL;

    if (!slug) {
      return null;
    }

    if (baseUrl && baseUrl.endsWith('/')) {
      return `${baseUrl}${slug}`;
    }

    return `${baseUrl}/${slug}`;
  }, [topic, slug]);

  if (!topic?.name || !topicLink) {
    return null;
  }

  return (
    <p className="mt-[16px]">
      <Trans i18nKey={'pages.collection.partOfTopicNote'} values={{ topicName: topic.name }}>
        Tato sbírka je součástí tématu{' '}
        <Link
          className="text-primary-mid hover:text-primary-dark underline hover:no-underline"
          href={topicLink}
          target="_blank"
          prefetch={process.env.NEXT_PUBLIC_PREFETCH_LINKS === 'true'}
        >
          {topic.name}
        </Link>
      </Trans>
    </p>
  );
};
